import * as tslib_1 from "tslib";
import { OnInit, EventEmitter } from '@angular/core';
import { ArrayHelper } from '../../../../models/helpers/array-helper';
import { IsInvalidDirective } from 'src/app/modules/core/directives/is-invalid.directive';
import { NgForm } from '@angular/forms';
import { ConfirmDeleteModalComponent } from 'src/app/modules/core/components/delete-modal/confirm-delete-modal-component';
import { CreateCustomerModalComponent } from './create-customer-modal/create-customer-modal.component';
import { Subject } from 'rxjs';
export class CertificatesComponent {
    constructor(plantingSiteService) {
        this.plantingSiteService = plantingSiteService;
        this.discardValues$ = new Subject();
        this.showCustomerOnSite$ = new Subject();
        this.certificatesChange = new EventEmitter();
        this.site = {
            id: '',
            certificates: [],
            partners: [],
            species: [],
            areas: [],
            collections: []
        };
        this._certificates = [];
        this.confirmDeleteMsg = "Are you sure you want to delete";
    }
    get selectedCustomer() {
        return this._selectedCustomer;
    }
    get certificates() {
        return this._certificates;
    }
    set certificates(value) {
        this._certificates = value;
        this.sortCollectionByCode();
    }
    get totalAvailableTrees() {
        return this.site.totalTrees - this.sumAllOfTrees;
    }
    ngOnInit() {
        this.calculateTotalAmount();
    }
    save(newcertificate) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.certificates.push(newcertificate);
            this.calculateTotalAmount();
            this.sortCollectionByCode();
            this.certificatesChange.emit(this._certificates);
            yield this.plantingSiteService.getById(this.site.id).then(site => {
                this.site = site;
            });
        });
    }
    updateCertificates(cert) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._certificates = [cert, ...this._certificates.filter(value => value.id != cert.id)];
            this._certificates = ArrayHelper.sortBy(this._certificates, true, coll => coll.code);
            this.calculateTotalAmount();
            this.sortCollectionByCode();
            this.certificatesChange.emit(this._certificates);
            yield this.plantingSiteService.getById(this.site.id).then(site => {
                this.site = site;
            });
            return cert.id;
        });
    }
    delete(cert) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.confirmDeleteModal.showAwait(this.confirmDeleteMsg);
            if (result) {
                let id = yield this.plantingSiteService.deletCertificate(cert.id);
                this._certificates = this._certificates.filter(x => x.id != id);
                this.calculateTotalAmount();
                this.sortCollectionByCode();
                this.certificatesChange.emit(this._certificates);
                yield this.plantingSiteService.getById(this.site.id).then(site => {
                    this.site = site;
                });
            }
        });
    }
    showCustomer() {
        this.createCustomerModal.show();
    }
    calculateTotalAmount() {
        if (this._certificates === undefined)
            return false;
        this.sumAllOfTrees = this._certificates.reduce((sum, current) => sum + +current.count, 0);
        this.misc = this.site.totalTrees - this.sumAllOfTrees;
    }
    updateCustomer(customer) {
        this.customers.push(customer);
        this.newCustomer = customer;
    }
    sortCollectionByCode() {
        this._certificates = ArrayHelper.sortBy(this._certificates, false, cert => cert.code);
    }
}
